type Feature = {
  n: string;
  title: string;
  body: string;
};

const FEATURES: Feature[] = [
  {
    n: 'Claros Calls',
    title: 'Decisions, not dashboards',
    body: 'A ranked, auditable list of what to do next across finance, people, product and market — each with its evidence, options, and the cost of each path. Accept, dismiss, or snooze; every choice lands on the record.',
  },
  {
    n: 'Always on',
    title: 'Assessed continuously',
    body: 'Claros re-reads the business as the numbers move, so a covenant breach or a new key-person risk becomes a call the moment it happens — not a surprise at quarter-end.',
  },
  {
    n: 'Explore',
    title: 'Ask in plain English',
    body: '“Turnover by department in the US.” Claros compiles the query, shows you exactly how it read the question, and runs it — no dashboards to configure, no analyst in the loop.',
  },
];

export function Features() {
  return (
    <section id="product" className="py-24 sm:py-28">
      <div className="container-page">
        <div className="grid gap-9 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((f) => (
            <div key={f.n} className="flex flex-col gap-3.5">
              <span className="h-0.5 w-8 rounded-full bg-accent-bright opacity-55" />
              <span className="font-mono text-[11.5px] uppercase tracking-[0.09em] text-accent-bright">
                {f.n}
              </span>
              <h3 className="text-[1.32rem]">{f.title}</h3>
              <p className="text-[15px] leading-relaxed text-ink-muted">
                {f.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
